import { API_URL_PROJECT } from "@constants/env";
import { apiProjectToDto } from "@helpers/project.helper";
import useApiCall from "@hooks/Shared/useApiCall";
import { IProject } from "@interfaces/project";

const useGetProject = (uuid: string) =>
  useApiCall<IProject>({
    url: API_URL_PROJECT + uuid,
    transformResponse: (data) =>
      apiProjectToDto(JSON.parse(data as string) as IProject),
  });

export default useGetProject;
